module.exports = __webpack_public_path__ + "static/media/icon-512x512.15a5695a.png";